<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="查询"
      permpisionsQuery
    >
      <section slot="sourceAddressInfo" slot-scope="prop">
        <ChooseAddress
          :showCloseBtn="true"
          :showCleanBtn="true"
          :selectType="2"
          placeholder="请选择始发地城市"
          v-model="prop.form.sourceAddressInfo"
        />
      </section>
      <section slot="desAddressInfo" slot-scope="prop">
        <ChooseAddress
          :showCloseBtn="true"
          :showCleanBtn="true"
          :selectType="2"
          placeholder="请选择目的地城市"
          v-model="prop.form.desAddressInfo"
        />
      </section>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  selectSysStaticDataByCodeType,
} from 'api';
import ChooseAddress from 'components/chooseAddress/chooseAddress';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
    ChooseAddress,
  },
  data () {
    return {
      searchBoxData: {
        lineStsOptions: [],
        form: [
          {
            label: '线路编码',
            value: 'customerLineNo',
            type: 'input',
            placeholder: '请输入线路编码',
          },
          {
            label: '线路关键字',
            value: 'lineKeyWord',
            type: 'input',
            placeholder: '请输入线路关键字',
          },
          {
            label: '客户全称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户全称',
          },
          {
            label: '线路名称',
            value: 'lineCodeName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          {
            label: '线路状态',
            value: 'lineSts',
            type: 'select',
            placeholder: '请选择线路状态',
            default: '1',
            options: [
              { label: '有效', value: '1' },
              { label: '删除', value: '0' },
            ],
          },
          {
            label: '始发地',
            value: 'sourceAddressInfo',
            slot: true,
            default: [],
          },
          {
            label: '目的地',
            value: 'desAddressInfo',
            slot: true,
            default: [],
          },
          {
            label: '有效期',
            value: 'validDays',
            type: 'select',
            placeholder: '请选择有效期',
            default: -1,
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '即将到期',
                value: 1,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.sourceAddressInfo && searchBoxData.sourceAddressInfo.length) {
        if (searchBoxData.sourceAddressInfo[0]) {
          searchBoxData.sourceProvince = `${searchBoxData.sourceAddressInfo[0]}`;
        }
        if (searchBoxData.sourceAddressInfo[1]) {
          searchBoxData.sourceCity = `${searchBoxData.sourceAddressInfo[1]}`;
        }
        delete searchBoxData.sourceAddressInfo;
      }

      if (searchBoxData.desAddressInfo && searchBoxData.desAddressInfo.length) {
        if (searchBoxData.desAddressInfo[0]) {
          searchBoxData.desProvince = `${searchBoxData.desAddressInfo[0]}`;
        }
        if (searchBoxData.desAddressInfo[1]) {
          searchBoxData.desCity = `${searchBoxData.desAddressInfo[1]}`;
        }
        delete searchBoxData.desAddressInfo;
      }
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
      });
    },
  },
  async created () {
    const lineStsOptions = await selectSysStaticDataByCodeType({
      codeType: 'CUCUSTOMER_LINE_STATE',
      hasAll: true,
    });
    this.searchBoxData.lineStsOptions = lineStsOptions;
  },
};
</script>

<style lang="scss" scoped>
</style>
